import { createReducer } from 'redux-act';
import { collectionSaveFinished, collectionSaveStarted } from '../../actions/collections';

export interface ICollectionSavingReducerState {
  /** `updateCollectionByPath` saves still waiting for the API; they run concurrently. */
  pending: number;
}

const initialState: ICollectionSavingReducerState = {
  pending: 0
};

export const collectionSaving = createReducer<ICollectionSavingReducerState>({}, initialState);

collectionSaving.on(collectionSaveStarted, (state: ICollectionSavingReducerState) => ({
  pending: state.pending + 1
}));

collectionSaving.on(collectionSaveFinished, (state: ICollectionSavingReducerState) => ({
  pending: Math.max(state.pending - 1, 0)
}));
